<script>
import helpForm from './helpForm.vue';
export default {
	name: 'help',
	data() {
		this.popupItems = {};
		return {
			helpId: null,
		};
	},
	methods: {
		//SỰ kiện mở link help
		async showHelp() {
			const me = this;
			let instance = await me.$ms.commonFunc.getPopupInstanceAsync(
				me.popupItems,
				helpForm
			);
			let options = {
				helpId: me.helpId,
			};
			instance.showPopup(options);
		},
	},
};
</script>